import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";

import { CancelButton, SaveButton } from "../../../common/Button";
// import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Col, Container, Row, Form, InputGroup } from "react-bootstrap";
import {
  VehicleCategory,
  AllCity,
} from "../../../../utils/apis/masters/masters";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
library.add(fas);
const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data.name);

      const response = await postData(
        `/masters/driver-terms-and-condition/${id}`,
        DataToSend
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/masters/driver-terms-and-condition/${id}`);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit User Help Type</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Container fluid>
            <Row>
              {/* Right side - Form */}
              <Col md={12}>
                <Card className="shadow-lg p-3 mb-5 bg-white rounded">
                  <Card.Body>
                    <Card.Title>Edit Drivers Terms and Conditions </Card.Title>
                    <hr />
                    <Container>
                      <Row>
                        {/* Editing fields */}
                        <Col md={8}>
                          <Form
                            onSubmit={() => handleSubmit(onSubmit)}
                            role="form"
                          >
                            {" "}
                            <Col lg={12}>
                              <div className="main-form-section mt-3">
                                <Row className="justify-content-start">
                                  {" "}
                                  <Col sm={12}>
                                    <Form.Label className="text-center">
                                      Name
                                    </Form.Label>
                                    <Form.Group>
                                      <Controller
                                        name="name"
                                        control={control}
                                        rules={{
                                          required: "Name is required.",
                                        }} // Correct the maxLength rule
                                        render={({
                                          field: { onChange, onBlur, value },
                                        }) => (
                                          <JoditEditor
                                            value={value}
                                            onBlur={() => {
                                              onBlur();
                                              trigger("name");
                                            }}
                                            onChange={onChange}
                                          />
                                        )}
                                      />
                                    </Form.Group>
                                    {errors.name && (
                                      <span className="text-danger">
                                        {errors.name.message}
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                            <Row className="mt-5 pb-3">
                              <div className="d-flex justify-content-center">
                                <Link>
                                  <CancelButton
                                    name={"cancel"}
                                    handleClose={props.handleClose}
                                  />
                                </Link>
                                <SaveButton
                                  name={"save"}
                                  handleSubmit={handleSubmit(onSubmit)}
                                />
                              </div>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default EditOffCanvance;
